// import Vue from 'vue'
import server from '../../api/server'
import utils from '../../api/utils'

// import moment from 'moment'

const state = {
  constant: {
    ACTIVE_SCOPE: 'ACTIVE_SCOPE',
    ALL_SCOPE: 'ALL_SCOPE'
  },
  clientCompany: null,
  cachedRefs: {},
  requests: null,
  isSearching: false
}

// getters
const getters = {
  getClientUrl: (state, getters) => (inn) => {
    return getters.getOpenSettings.linkBaseUrl + '/pages/' + inn
  },
  getRefIsValid: (state, getters) => (ref) => {
    var kind = ['ogrn', 'nza', 'ogrnip', 'COMPANY', 'HUMAN', 'FOREIGN', 'FAGENCY']
    var rArr = ref.split(':')
    return rArr.length > 1 && kind.indexOf(rArr[0]) >= 0 && rArr[1] !== '0' && rArr[1] !== 'null'
  },
  getRefToUrl: (state, getters) => (ref, profileId) => {
    var rArr = ref.split(':')
    switch (rArr[0]) {
      case 'ogrn':
        return '#/clients/' + rArr[1] + (profileId ? '?profileId=' + profileId : '')
      case 'HUMAN':
        return '#/humans/' + rArr[1]
      case 'FOREIGN':
        return '#/foreigns/' + rArr[1]
      case 'PERSON':
        return '#/people/' + rArr[1]
      case 'nza':
        return '#/fagency/' + rArr[1] + (profileId ? '?profileId=' + profileId : '')
      case 'ogrnip':
        return '#/loners/' + rArr[1]
    }
    return '#/clients/' + rArr[1]
  },
  getClientCompany: state => state.clientCompany
}

// actions
const actions = {
  copyCompanyLink ({commit, state}, url) {
    utils.copyTextToClipboard(url)
    commit('setStatus', {show: true, type: 'success', message: 'Ссылка на страницу компании скопирована в буфер обмена.'})
  },
  getCachedRefs ({commit, state}, request) {
    return new Promise((resolve, reject) => {
      var refcodesStr = request.refcodes.join(',')
      if (state.cachedRefs[refcodesStr]) {
        resolve(state.cachedRefs[refcodesStr])
        return
      }
      server.openApiGetParams(
        '/openapi/cached/refs',
        {
          id: refcodesStr
        },
        (data) => {
          commit('setCachedRefs', {key: refcodesStr, value: data})
          resolve(data)
        },
        (e) => {
          commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении кешированной информвции о компаниях '})
          reject(e)
        }
      )
    })
  },
  getBriefCompaniesByInn ({commit, state}, request) {
    return new Promise((resolve, reject) => {
      var refcodesStr = request.inns.map(inn => `inn:${inn}`).join(',')
      if (state.cachedRefs[refcodesStr]) {
        resolve(state.cachedRefs[refcodesStr])
        return
      }
      server.openApiGetParams(
        '/openapi/briefs',
        {
          id: refcodesStr
        },
        (data) => {
          commit('setCachedRefs', {key: refcodesStr, value: data})
          resolve(data)
        },
        (e) => {
          commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении информвции о компаниях '})
          reject(e)
        }
      )
    })
  },
  getBriefCompaniesByRefCode ({commit, state}, request) {
    return new Promise((resolve, reject) => {
      var refcodesStr = request.refCodes.join(',')
      if (state.cachedRefs[refcodesStr]) {
        resolve(state.cachedRefs[refcodesStr])
        return
      }
      server.openApiGetParams(
        '/openapi/briefs',
        {
          id: refcodesStr
        },
        (data) => {
          commit('setCachedRefs', {key: refcodesStr, value: data})
          resolve(data)
        },
        (e) => {
          commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении информвции о компаниях '})
          reject(e)
        }
      )
    })
  },
  getBriefCompanies ({commit, state}, request) {
    return new Promise((resolve, reject) => {
      var innsStr = request.inns.join(',')
      innsStr = innsStr.replaceAll('nza:', '').replaceAll('ogrn:', '').replaceAll('ogrnip:', '').replaceAll('inn:', '')
      if (state.cachedRefs[innsStr]) {
        resolve(state.cachedRefs[innsStr])
        return
      }
      let params = {size: request.inns.length, page: 0, request: {search: innsStr}}
      server.openApiGetParams(
        '/openapi/companies', params,
        (data) => {
          let dtos = data.content.map(c => c.ref)
          resolve(dtos)
        },
        (e) => {
          commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении списка компаний  '})
          reject(e)
        })
    })
  },
  convertInnToRefCode ({commit, state, rootState}, request) {
    return new Promise((resolve, reject) => {
      server.openApiPost(
        '/openapi/command-code-converts',
        {codes: request.inns},
        (data) => {
          resolve(data)
        },
        (e) => {
          commit('setErrorStatus', {error: e, context: 'Ошибка сервера при добавлении контрагента в избранное '})
          reject(e)
        })
    })
  }
}

// mutations
const mutations = {
  setClientCompany (state, company) {
    state.clientCompany = company
  },
  setCachedRefs (state, pair) {
    state.cachedRefs[pair.key] = pair.value
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/client.js